import GiftOrderApi from '@apis/gift/GiftOrderApi';
import AppModal from '@components/AppModal';
import Text from '@components/Text';
import { ErrorResponse } from '@models/error';
import { CancelGiftOrderRequest } from '@models/gift';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

declare module '@stackflow/config' {
    interface Register {
        GiftCancelModal: CancelGiftOrderRequest;
    }
}

const GiftCancelModal: ActivityComponentType<'GiftCancelModal'> = ({ params }) => {
    const { pop, push } = useFlow();
    const { t } = useTranslation('gift');
    const handleCancel = () => {
        GiftOrderApi.cancelOrder(params)
            .then(() => {
                pop(2);
                push('GiftCanceledModal', {});
            }).catch((e: AxiosError<ErrorResponse>) => {
                toast.error(e.message);
            });
    };
    return (
        <AppModal title={t('giftCancelModal.title')}
            deny={t('giftCancelModal.cancel')}
            confirm={t('giftCancelModal.confirm')}
            onConfirm={handleCancel} >
            <Text size='title-lg' align='center'>
                {t('giftCancelModal.description')}
            </Text>
        </AppModal>
    );
};

export default GiftCancelModal;
